class MyPurchaseRecordsController {
  constructor (SubscriptionService, VehicleService, $scope, $rootScope, MetricsService) {
    'ngInject'
    this.subscriptionService = SubscriptionService
    this.vehicleService = VehicleService
    this.$scope = $scope
    this.$rootScope = $rootScope

    this.records = []
    this.page = 1
    this.nbItemPerPage = 4
    this.isMore = false
    this.isProcessing = true
    this.metricsService = MetricsService

    // Async loading...
    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentSelectedVehicle()
    .then((v) => {
      if (!v) {
        return Promise.reject()
      }
      this.vehicle = v
      const params = {
        vin: v.vin,
        page: this.page,
        nbItemPerPage: this.nbItemPerPage
      }
      return this.subscriptionService.getSubscriptions(params)
    })
    .then((res) => {
      this.isProcessing = false
      this.error = null
      this.records = this.records.concat(res.subscriptions)
      this.total = res.total
      this.isMore = this.records.length < this.total
      this.safeApply()
      return Promise.resolve(this.records)
    }, (err) => {
      this.isProcessing = false
      this.error = {
        message: 'purchase-record.error',
        cause: err
      }
      this.safeApply()
      return Promise.reject(err)
    })
  }

  more () {
    this.isProcessing = true
    this.page++
    this.init()
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }
}

export default MyPurchaseRecordsController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-purchase-records/my-purchase-records.controller.js